import { useMutation, useQuery } from "react-query";
import * as contentReportsService from 'services/contentReportsService';
import { ListContentReportsDto } from "types/dto/ListContentReportsDto";

export const useGetContentReports = (dto: ListContentReportsDto, options = {}) => {
  return useQuery({
    queryKey: ['contentReports', dto],
    queryFn: () => contentReportsService.getContentReports(dto),
    ...options
  });
}

export const useResolveContentReport = (onSuccess?: () => void, onError?: (error: any) => void) => {
  return useMutation(contentReportsService.resolveContentReport, {
    onSuccess,
    onError,
  });
}
